import { render, staticRenderFns } from "./WarehouseSelectorForm.vue?vue&type=template&id=2068f932&"
import script from "./WarehouseSelectorForm.vue?vue&type=script&lang=js&"
export * from "./WarehouseSelectorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.hva/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormSelect, BButton, BModal} from 'bootstrap-vue'
    installComponents(component, {BFormSelect, BButton, BModal})
    

export default component.exports